module.exports = __webpack_public_path__ + "static/media/image3.dbbc8095.png";